import $ from 'jquery';

export default (selector) => {
  $(selector).parsley({
    errorClass: 'newsletter-form__input--invalid',
    successClass: 'newsletter-form__input--success',
    errorsWrapper: '<div class="newsletter-form__validation-wrap newsletter-form__validation-wrap--active"></div>',
    errorTemplate: '<p class="newsletter-form__validation-message"></p>',
  });
};
